import { type FC } from "react";

import { Button, type ButtonProps, Tooltip, type TooltipProps } from "@snapchat/snap-design-system";

import { fakeButtonCSS, triggerCSS } from "./ButtonDisabledTooltip.styles";

type ButtonDisabledTooltipProps = ButtonProps & {
    tooltip?: Omit<TooltipProps, "children">;
};

export const ButtonDisabledTooltip: FC<ButtonDisabledTooltipProps> = ({
    children,
    tooltip,
    isDisabled,
    ...buttonProps
}) => {
    return isDisabled && tooltip?.content ? (
        <Tooltip {...tooltip}>
            {/* A disabled button gets no pointer events, so the overlay is the hover target. */}
            <span className={triggerCSS}>
                <span className={fakeButtonCSS} />
                <Button isDisabled={isDisabled} {...buttonProps}>
                    {children}
                </Button>
            </span>
        </Tooltip>
    ) : (
        <Button isDisabled={isDisabled} {...buttonProps}>
            {children}
        </Button>
    );
};
